import React, {
    useContext,
    useState
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { NotificationContext, handleError } from '../router'

import * as QUERIES from "../query-functions";

import TicketQuantityButtons from "../components/ticket-quantity-buttons"
import LoadingIndicator from '../components/loading-indicator';

export default function ExtrasInstance(props) {

    const {notification, setNotification} = useContext(NotificationContext);

    const [ticketQuantity, setTicketQuantity] = useState(1);
    const [successMessage, setSuccessMessage] = useState(null);

    const price = props.instance?.priceList?.prices ? props.instance.priceList.prices[0] : null;

    const addTickets = useMutation({
        mutationFn: () => QUERIES.addTickets(ticketQuantity, price.ticketType.id, "", props.instance.id, props.instance.planId),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            setSuccessMessage("Tickets are added to basket.")
        },
    })
    
    return (
        <article className='extras-instance stack'>

            <img src={props.instance.event.thumbnailUrl } className='extras-instance__image' />
            
            <header className='extras-instance__header'>
                <div className='extras-instance__header--content'>
                    <h3 className='extras-instance__title'>{ props.instance.event.name }</h3>

                    { price && (
                        <p className='extras-instance__price'>£{ price.amount.toFixed(2) }</p>
                    )}
                </div>
            </header>

            <div className='extras-instance__summary'>
                <p>{ props.instance.event.description }</p>
            </div>

            <div className='extras-instance__footer'>
                <TicketQuantityButtons ticketQuantity={ticketQuantity} setTicketQuantity={setTicketQuantity} />

                <button className='btn' 
                    type="button" 
                    onClick={() => { addTickets.mutateAsync(); setSuccessMessage(null)}}
                    disabled={addTickets.isPending}>
                    Add to basket
                    {addTickets.isPending &&
                        <LoadingIndicator />
                    }
                </button>
            </div>

            {successMessage &&
                <p className='confirmation-message'>{successMessage}</p>
            }
        </article>
    );
}